import { render, staticRenderFns } from "./transfer.vue?vue&type=template&id=34fdb8b6&scoped=true"
import script from "./transfer.vue?vue&type=script&lang=ts"
export * from "./transfer.vue?vue&type=script&lang=ts"
import style0 from "./transfer.vue?vue&type=style&index=0&id=34fdb8b6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34fdb8b6",
  null
  
)

export default component.exports